export const ActionTypes = {
    SET_PRODUCTS: "SET_PRODUCTS",
    SELECT_PRODUCT: "SELECT_PRODUCT",
    ADD_TO_CARD: "ADD_TO_CARD",
    DELETE_IN_CARD: "DELETE_IN_CARD",
    SET_CATEG_PRODUCTS: "SET_CATEG_PRODUCTS",
    REMOVE_SELECTED_PRODUCT: "REMOVE_SELECTED_PRODUCT",
    ADD_PRODUCT: "ADD_PRODUCT",
    DELETE_ALL_CARD: "DELETE_ALL_CARD",
}